import React from 'react';

import PropTypes from 'prop-types';
import { FaMapMarkerAlt } from 'react-icons/fa';

import Badge from 'modules/common/components/Badge';
import AddressDetails from 'modules/merchant/order-management/all-orders/components/AddressDetails';
import Tracker from 'modules/common/components/Tracker';
import { transformOrderLogs } from 'modules/merchant/order-management/all-orders/transformer';

import Notification from '../components/Notification';

const renderBadge = {
  FOR_PICKUP: {
    type: 'warning',
    label: 'For Confirmation',
  },
  IN_TRANSIT: {
    type: 'info',
    label: 'On Delivery',
  },
  DELIVERED: {
    type: 'success',
    label: 'Completed',
  },
};

function DeliveryCard({ data }) {
  const { system_status, order_number } = data;
  const orderLogs = React.useMemo(
    () => transformOrderLogs(data?.orderLogs),
    [data.orderLogs]
  );

  return (
    <div className="card space-y-4">
      <div className="space-y-2">
        <div className="flex justify-between items-center">
          <h4 className="text-xs text-gray-400 tracking-wide font-semibold">
            ORDER NUMBER
          </h4>
          {system_status && (
            <Badge
              type={renderBadge[system_status]?.type}
              label={renderBadge[system_status]?.label}
            />
          )}
        </div>
        <div className="text-2xl font-bold">{order_number}</div>
      </div>
      <Notification status={system_status} />
      {orderLogs?.length > 0 && (
        <div className="space-y-4 xl:col-span-1">
          <h4 className="font-medium text-gray-400 text-xs">TIMELINE</h4>
          <Tracker
            lineStyle="dashed"
            finalIcon={<FaMapMarkerAlt className="h-6 w-6 text-primary-500" />}
            data={orderLogs}
          />
        </div>
      )}
      <AddressDetails data={data} />
    </div>
  );
}
DeliveryCard.defaultProps = {};

DeliveryCard.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
};

export default DeliveryCard;
